/// <reference types="vite/client" />
import DashboardIcon from "@assets/tsxIcons/DashboardIcon";
import CustomerIcon from "@assets/tsxIcons/CustomerIcon";

import dashboardImg from "@assets/images/FeaturesPopupImages/Dashboard.png";
import bookingModImg from "@assets/images/FeaturesPopupImages/BookingModule.png";
import eventCalImg from "@assets/images/FeaturesPopupImages/EventCalendar.png";
import subscribersImg from "@assets/images/FeaturesPopupImages/Subscribers.png";
import notificationsCenImg from "@assets/images/FeaturesPopupImages/NotificationCenter.png";
import UserAndPerImg from "@assets/images/FeaturesPopupImages/User&Permissions.png";
import statisticsImg from "@assets/images/FeaturesPopupImages/Statistics.png";
import MembershipImg from "@assets/images/FeaturesPopupImages/Membership&Pricing.png";
import uiRefinementsImg from "@assets/images/FeaturesPopupImages/UIRefinements.png";
import bugFixesImg from "@assets/images/FeaturesPopupImages/BugFixes.png";
import BookingIcon from "@assets/tsxIcons/BookingIcon";
import LessonIcon from "@assets/tsxIcons/LessonIcon";
import EventIcon from "@assets/tsxIcons/EventIcon";
import MembershipIcon from "@assets/tsxIcons/MembershipIcon";
import TransactionIcon from "@assets/tsxIcons/TransactionIcon";
import InboxIcon from "@assets/tsxIcons/InboxIcon";
import AnalyticsIcon from "@assets/tsxIcons/AnalyticsIcon";
import PosIcon from "@assets/tsxIcons/PosIcon";
import LeagueManagerIcon from "@assets/tsxIcons/LeagueManagerIcon";
import SocialMiner from "@assets/tsxIcons/SocialMiner";
import MarketingEngine from "@assets/tsxIcons/MarketingEngine";
import ReportingIcon from "@assets/tsxIcons/ReportingIcon";
import WebsiteCMSIcon from "@assets/tsxIcons/WebsiteCMSIcon";

export const pageSize = 10;

export const weekDays = [
  {
    name: "Sunday",
  },
  {
    name: "Monday",
  },
  {
    name: "Tuesday",
  },
  {
    name: "Wednesday",
  },
  {
    name: "Thursday",
  },
  {
    name: "Friday",
  },
  {
    name: "Saturday",
  },
];

export const hoursList = [
  { hour: "09:00 AM", price: "$30.00", discount: "$30.00" },
  { hour: "10:00 AM", price: "$30.00", discount: "$30.00" },
  { hour: "11:00 AM", price: "$30.00", discount: "$30.00" },
  { hour: "12:00 PM", price: "$30.00", discount: "$30.00" },
  { hour: "01:00 PM", price: "$30.00", discount: "$30.00" },
  { hour: "02:00 PM", price: "$30.00", discount: "$30.00" },
  { hour: "03:00 PM", price: "$30.00", discount: "$30.00" },
];

export const operationalHours = [
  { value: "12:00 AM", label: "12:00 AM" },
  { value: "12:30 AM", label: "12:30 AM" },
  { value: "01:00 AM", label: "01:00 AM" },
  { value: "01:30 AM", label: "01:30 AM" },
  { value: "02:00 AM", label: "02:00 AM" },
  { value: "02:30 AM", label: "02:30 AM" },
  { value: "03:00 AM", label: "03:00 AM" },
  { value: "03:30 AM", label: "03:30 AM" },
  { value: "04:00 AM", label: "04:00 AM" },
  { value: "04:30 AM", label: "04:30 AM" },
  { value: "05:00 AM", label: "05:00 AM" },
  { value: "05:30 AM", label: "05:30 AM" },
  { value: "06:00 AM", label: "06:00 AM" },
  { value: "06:30 AM", label: "06:30 AM" },
  { value: "07:00 AM", label: "07:00 AM" },
  { value: "07:30 AM", label: "07:30 AM" },
  { value: "08:00 AM", label: "08:00 AM" },
  { value: "08:30 AM", label: "08:30 AM" },
  { value: "09:00 AM", label: "09:00 AM" },
  { value: "09:30 AM", label: "09:30 AM" },
  { value: "10:00 AM", label: "10:00 AM" },
  { value: "10:30 AM", label: "10:30 AM" },
  { value: "11:00 AM", label: "11:00 AM" },
  { value: "11:30 AM", label: "11:30 AM" },
  { value: "12:00 PM", label: "12:00 PM" },
  { value: "12:30 PM", label: "12:30 PM" },
  { value: "01:00 PM", label: "01:00 PM" },
  { value: "01:30 PM", label: "01:30 PM" },
  { value: "02:00 PM", label: "02:00 PM" },
  { value: "02:30 PM", label: "02:30 PM" },
  { value: "03:00 PM", label: "03:00 PM" },
  { value: "03:30 PM", label: "03:30 PM" },
  { value: "04:00 PM", label: "04:00 PM" },
  { value: "04:30 PM", label: "04:30 PM" },
  { value: "05:00 PM", label: "05:00 PM" },
  { value: "05:30 PM", label: "05:30 PM" },
  { value: "06:00 PM", label: "06:00 PM" },
  { value: "06:30 PM", label: "06:30 PM" },
  { value: "07:00 PM", label: "07:00 PM" },
  { value: "07:30 PM", label: "07:30 PM" },
  { value: "08:00 PM", label: "08:00 PM" },
  { value: "08:30 PM", label: "08:30 PM" },
  { value: "09:00 PM", label: "09:00 PM" },
  { value: "09:30 PM", label: "09:30 PM" },
  { value: "10:00 PM", label: "10:00 PM" },
  { value: "10:30 PM", label: "10:30 PM" },
  { value: "11:00 PM", label: "11:00 PM" },
  { value: "11:30 PM", label: "11:30 PM" },
];

export const daySlots = [
  { label: "Monday", slots: [{ startTime: "", endTime: "" }] },
  { label: "Tuesday", slots: [{ startTime: "", endTime: "" }] },
  { label: "Wednesday", slots: [{ startTime: "", endTime: "" }] },
  { label: "Thursday", slots: [{ startTime: "", endTime: "" }] },
  { label: "Friday", slots: [{ startTime: "", endTime: "" }] },
  { label: "Saturday", slots: [{ startTime: "", endTime: "" }] },
  { label: "Sunday", slots: [{ startTime: "", endTime: "" }] },
];
export const lessonTypes = [
  { label: "Adults", value: "adults" },
  { label: "Club Fitting", value: "club_fitting" },
  { label: "Juniors", value: "juniors" },
];
export const bookingTabs = [
  {
    label: "Bookings",
    path: ["/bookings", "/booking/calendar", "/bookings/monthly"],
  },
  { label: "Waitlist", path: "/bookings/waitlist" },
  { label: "Cancelations", path: "/bookings/cancellations" },
  { label: "Operating Hours", path: "/bookings/operation-hours" },
];
export const leagueAndEventsTabs = [
  { label: "Calendar Events", path: ["/league-events", "/events/calendar"] },

  { label: "Event Contacts", path: "/events/event-contacts" },
  // { label: "Subscribers", path: "/league/subscribers" },
];

export const analyticsTabs = [
  { label: "Analytics Dashboard", path: "/analytics" },
  { label: "Insights & Recommendations", path: "/analytics/insights" },
  { label: "Reports Schedule", path: "/analytics/reports_schedule" },
];

export const transactionTabs = [
  { label: "Transactions", path: "/transaction" },
];
export const subscriptionTabs = [
  { label: "Contact Form", path: "/inbox/contact-form" },
  { label: "Newsletter", path: "/inbox/newsletter" },
  { label: "Leagues", path: "/inbox/leagues" },
  { label: "Events", path: "/inbox/events" },
];
export const settingsTab = [
  { label: "Booking Settings", path: "/settings/bookings" },
  { label: "Venue Settings", path: "/settings/venue" },
  { label: "Pricing", path: "/settings/pricing" },
  { label: "Users & Permissions", path: "/settings" },
  { label: "Language & Regional", path: "/settings/language" },
  { label: "Notifications", path: "/settings/notifications" },
];

export const membershipTabs = [
  { label: "Membership Plans", path: "/membership/plans" },
  { label: "Members", path: "/membership/members" },
];

export const notificationTabs = [
  { label: "Notifications", path: "/notification" },
];

export const lessonsTabs = [
  {
    label: "Lessons & Fittings",
    path: ["/lessons/list", "/lessons/calendar"],
  },
  { label: "Coaches", path: "/lessons/coaches" },
  { label: "Coach Availability", path: "/lessons/coach-availability" },
];

export const featuresPopupTabs = [
  {
    name: "Dashboard",
    label: "A Renewed Dashboard",
    image: dashboardImg,
    content: [
      {
        text: "Real-time website analytics (visitors, visitor-to-booking ratio, graphs)",
      },
      {
        text: "Live event feed with quick links 🔗",
      },
      {
        text: "Cleaner, responsive UI: Auto-collapsing sidebar, refined iconography, improved spacing / typography",
      },
    ],
  },
  {
    name: "Booking Module",
    label: "Improved Booking Module",
    image: bookingModImg,
    content: [
      {
        text: "Daily view shows bookings and events side-by-side",
      },
      {
        text: "Block / Unblock Bays with smart conflict handling",
      },
      {
        text: "Monthly view: Daily booking % + export 📤",
      },
      {
        text: "Bug fix: Extending existing bookings now updates availability & pricing correctly ✅",
      },
    ],
  },
  {
    name: "Event Calendar",
    label: "Event Calendar",
    image: eventCalImg,
    content: [
      {
        text: "Events displayed alongside regular bookings",
      },
      {
        text: "Conflict-aware event creation (same 🤖 Auto Resolve tools)",
      },
      {
        text: "👥 Assign contacts to events",
      },
    ],
  },
  {
    name: "Subscriber & Contact Management",
    label: "Subscriber & Contact Management",
    image: subscribersImg,
    content: [
      {
        text: "Contact-form leads: view / edit / acknowledge / delete",
      },
      {
        text: "Newsletter list: edit / delete",
      },
      {
        text: "Dedicated contact lists for leagues & events",
      },
    ],
  },
  {
    name: "Notification Center",
    label: "Notification Center",
    image: notificationsCenImg,
    content: [
      {
        text: "Role-based preferences (Booking, Finance, Admin, Employee)",
      },
      {
        text: "Real-time panel: view 👁️ / mark read ✅ / bulk actions 🗑️",
      },
    ],
  },
  {
    name: "User & Permissions",
    label: "User & Permissions",
    image: UserAndPerImg,
    content: [
      {
        text: "Roles: Admin, Employee, Finance, Booking Manager",
      },
      {
        text: "Granular module access; invite via email, activate / deactivate users",
      },
    ],
  },
  {
    name: "Statistics",
    label: "Statistics",
    image: statisticsImg,
    content: [
      {
        text: "Customers & Members (total, active, cancelled)",
      },
      {
        text: "Live totals for bookings, events, contact forms, newsletters, leagues",
      },
    ],
  },
  {
    name: "Membership & Pricing",
    label: "Membership & Pricing",
    image: MembershipImg,
    content: [
      {
        text: "Weekly booking limit ⏱️ with tooltips ",
      },
      {
        text: "🖼️ Image-crop tool for events & plan thumbnails",
      },
      {
        text: "Global simulator base-price settings reflected across calendar",
      },
    ],
  },
  {
    name: "UI / UX Refinements",
    label: "UI / UX Refinements",
    image: uiRefinementsImg,
    content: [
      {
        text: "Sidebar auto-collapse, overall spacing & typography tweaks",
      },
    ],
  },
  {
    name: "Bug Fixes",
    label: "Bug Fixes",
    image: bugFixesImg,
    content: [
      {
        text: "Extending existing bookings now works as expected ✅",
      },
      {
        text: "Full booking summary visible in detail view",
      },
      {
        text: "Correct “Auto-Renewal: No” on cancelled memberships",
      },
      {
        text: "Date-range & type filters fixed in Transactions",
      },
      {
        text: "Tooltips & weekly limits added to membership plans",
      },
    ],
  },
];

export const appRoutes = [
  {
    image: DashboardIcon,
    title: "Dashboard",
    path: "/dashboard",
    isComing: false,
  },
  {
    image: CustomerIcon,
    title: "Customers",
    path: "/customers",
    isComing: false,
  },
  {
    image: BookingIcon,
    title: "Bookings",
    path: "/booking/calendar",
    isComing: false,
  },
  {
    image: LessonIcon,
    title: "Lessons",
    path: "/lessons/list",
    isComing: false,
  },
  {
    image: EventIcon,
    title: "Events Calendar",
    path: "/events/calendar",
    isComing: false,
  },
  {
    image: MembershipIcon,
    title: "Memberships",
    path: "/membership/plans",
    isComing: false,
  },
  {
    image: TransactionIcon,
    title: "Transactions",
    path: "/transaction",
    isComing: false,
  },
  {
    image: InboxIcon,
    title: "Inbox",
    path: "/inbox/contact-form",
    isComing: false,
  },
  {
    image: AnalyticsIcon,
    title: "Analytics",
    path: "/analytics",
    isComing: false,
  },
  {
    image: WebsiteCMSIcon,
    title: "Website CMS",
    path: "/website-cms/branding",
    isComing: false,
  },
  {
    image: PosIcon,
    title: "POS",
    path: "/pos",
    isComing: true,
  },
  {
    image: LeagueManagerIcon,
    title: "League Manager",
    path: "/league-manager",
    isComing: true,
  },
  {
    image: SocialMiner,
    title: "Social Miner",
    path: "/social-miner",
    isComing: true,
  },
  {
    image: MarketingEngine,
    title: "Marketing Engine",
    path: "/marketing-engine",
    isComing: true,
  },
  {
    image: ReportingIcon,
    title: "Reporting & Analytics",
    path: "/reporting",
    isComing: true,
  },
];

export const customerOptions = [
  {
    label: "John",
    value: "john",
  },
  {
    label: "Ben",
    value: "ben",
  },
];

export const bookingStatus = [
  {
    value: "Pending",
    label: "Pending",
  },
  {
    value: "Confirmed",
    label: "Confirmed",
  },
  {
    value: "Completed",
    label: "Completed",
  },
  {
    value: "Canceled",
    label: "Canceled",
  },
  {
    value: "Temporary",
    label: "Temporary",
  },
];

export const bookingPayments = [
  {
    value: "credit_card",
    label: "Paid Credit Card",
  },
  {
    value: "membership",
    label: "Paid membership",
  },
  {
    value: "gift_cards",
    label: "Paid Gift Cards",
  },
  {
    value: "unpaid",
    label: "Unpaid",
  },
  {
    value: "cash",
    label: "Cash",
  },
];

export const bookingSources = [
  {
    value: "phone",
    label: "Phone",
  },
  {
    value: "walk_in",
    label: "Walk-In",
  },
  {
    value: "website",
    label: "Website",
  },
  {
    value: "quick_booking",
    label: "Quick Booking",
  },
];

export const baySelectionList = [
  { name: "Bay 1", status: "Available" },
  { name: "Bay 2", status: "Available" },
  { name: "Bay 3", status: "Unavailable" },
  { name: "Bay 4", status: "Available" },
  { name: "Bay 5", status: "Available" },
  { name: "Bay 6", status: "Available" },
  { name: "Bay 7", status: "Available" },
];

export const bookingMinutes = ["60", "90", "120", "180"];

export const timeOptions = [
  {
    startTime: [{ start: "09:00 AM" }, { start: "09:30 AM" }],
    endTime: [{ end: "09:30 AM" }, { end: "10:00 AM" }],
    amount: "30.00",
  },
  {
    startTime: [{ start: "10:00 AM" }, { start: "10:30 AM" }],
    endTime: [{ end: "10:30 AM" }, { end: "11:00 AM" }],
    amount: "30.00",
  },
  {
    startTime: [{ start: "11:00 AM" }, { start: "11:30 AM" }],
    endTime: [{ end: "11:30 AM" }, { end: "12:00 PM" }],
    amount: "30.00",
  },
  {
    startTime: [{ start: "12:00 PM" }, { start: "12:30 PM" }],
    endTime: [{ end: "12:30 PM" }, { end: "1:00 PM" }],
    amount: "30.00",
  },
];

export const statesList = [
  { value: "alabama", label: "Alabama" },
  { value: "alaska", label: "Alaska" },
  { value: "arizona", label: "Arizona" },
  { value: "arkansas", label: "Arkansas" },
  { value: "california", label: "California" },
  { value: "colorado", label: "Colorado" },
  { value: "connecticut", label: "Connecticut" },
  { value: "delaware", label: "Delaware" },
  { value: "florida", label: "Florida" },
  { value: "georgia", label: "Georgia" },
  { value: "hawaii", label: "Hawaii" },
  { value: "idaho", label: "Idaho" },
  { value: "illinois", label: "Illinois" },
  { value: "indiana", label: "Indiana" },
  { value: "iowa", label: "Iowa" },
  { value: "kansas", label: "Kansas" },
  { value: "kentucky", label: "Kentucky" },
  { value: "louisiana", label: "Louisiana" },
  { value: "maine", label: "Maine" },
  { value: "maryland", label: "Maryland" },
  { value: "massachusetts", label: "Massachusetts" },
  { value: "michigan", label: "Michigan" },
  { value: "minnesota", label: "Minnesota" },
  { value: "mississippi", label: "Mississippi" },
  { value: "missouri", label: "Missouri" },
  { value: "montana", label: "Montana" },
  { value: "nebraska", label: "Nebraska" },
  { value: "nevada", label: "Nevada" },
  { value: "new_hampshire", label: "New Hampshire" },
  { value: "new_jersey", label: "New Jersey" },
  { value: "new_mexico", label: "New Mexico" },
  { value: "new_york", label: "New York" },
  { value: "north_carolina", label: "North Carolina" },
  { value: "north_dakota", label: "North Dakota" },
  { value: "ohio", label: "Ohio" },
  { value: "oklahoma", label: "Oklahoma" },
  { value: "oregon", label: "Oregon" },
  { value: "pennsylvania", label: "Pennsylvania" },
  { value: "rhode_island", label: "Rhode Island" },
  { value: "south_carolina", label: "South Carolina" },
  { value: "south_dakota", label: "South Dakota" },
  { value: "tennessee", label: "Tennessee" },
  { value: "texas", label: "Texas" },
  { value: "utah", label: "Utah" },
  { value: "vermont", label: "Vermont" },
  { value: "virginia", label: "Virginia" },
  { value: "washington", label: "Washington" },
  { value: "west_virginia", label: "West Virginia" },
  { value: "wisconsin", label: "Wisconsin" },
  { value: "wyoming", label: "Wyoming" },
];

export const citiesList = [
  {
    value: "dothan",
    label: "Dothan",
  },
  {
    value: "athens",
    label: "Athens",
  },
  {
    value: "chickasaw",
    label: "Chickasaw",
  },
];

export const bookingTimeout = [
  {
    value: "5 minutes",
    label: "5 minutes",
  },
  {
    value: "6 minutes",
    label: "6 minutes",
  },
  {
    value: "7 minutes",
    label: "7 minutes",
  },
  {
    value: "8 minutes",
    label: "8 minutes",
  },
  {
    value: "9 minutes",
    label: "9 minutes",
  },
  {
    value: "10 minutes",
    label: "10 minutes",
  },
  {
    value: "11 minutes",
    label: "11 minutes",
  },
  {
    value: "12 minutes",
    label: "12 minutes",
  },
  {
    value: "13 minutes",
    label: "13 minutes",
  },
  {
    value: "14 minutes",
    label: "14 minutes",
  },
  {
    value: "15 minutes",
    label: "15 minutes",
  },
  {
    value: "16 minutes",
    label: "16 minutes",
  },
  {
    value: "17 minutes",
    label: "17 minutes",
  },
  {
    value: "18 minutes",
    label: "18 minutes",
  },
  {
    value: "19 minutes",
    label: "19 minutes",
  },
  {
    value: "20 minutes",
    label: "20 minutes",
  },
  {
    value: "21 minutes",
    label: "21 minutes",
  },
  {
    value: "22 minutes",
    label: "22 minutes",
  },
  {
    value: "23 minutes",
    label: "23 minutes",
  },
  {
    value: "24 minutes",
    label: "24 minutes",
  },
  {
    value: "25 minutes",
    label: "25 minutes",
  },
  {
    value: "26 minutes",
    label: "26 minutes",
  },
  {
    value: "27 minutes",
    label: "27 minutes",
  },
  {
    value: "28 minutes",
    label: "28 minutes",
  },
  {
    value: "29 minutes",
    label: "29 minutes",
  },
  {
    value: "30 minutes",
    label: "30 minutes",
  },
];

export const pastHourGracePeriod = [
  {
    value: "1 minutes",
    label: "1 minutes",
  },
  {
    value: "2 minutes",
    label: "2 minutes",
  },
  {
    value: "3 minutes",
    label: "3 minutes",
  },
  {
    value: "4 minutes",
    label: "4 minutes",
  },
  {
    value: "5 minutes",
    label: "5 minutes",
  },
  {
    value: "6 minutes",
    label: "6 minutes",
  },
  {
    value: "7 minutes",
    label: "7 minutes",
  },
  {
    value: "8 minutes",
    label: "8 minutes",
  },
  {
    value: "9 minutes",
    label: "9 minutes",
  },
  {
    value: "10 minutes",
    label: "10 minutes",
  },
  {
    value: "11 minutes",
    label: "11 minutes",
  },
  {
    value: "12 minutes",
    label: "12 minutes",
  },
  {
    value: "13 minutes",
    label: "13 minutes",
  },
  {
    value: "14 minutes",
    label: "14 minutes",
  },
  {
    value: "15 minutes",
    label: "15 minutes",
  },
  {
    value: "16 minutes",
    label: "16 minutes",
  },
  {
    value: "17 minutes",
    label: "17 minutes",
  },
  {
    value: "18 minutes",
    label: "18 minutes",
  },
  {
    value: "19 minutes",
    label: "19 minutes",
  },
  {
    value: "20 minutes",
    label: "20 minutes",
  },
  {
    value: "21 minutes",
    label: "21 minutes",
  },
  {
    value: "22 minutes",
    label: "22 minutes",
  },
  {
    value: "23 minutes",
    label: "23 minutes",
  },
  {
    value: "24 minutes",
    label: "24 minutes",
  },
  {
    value: "25 minutes",
    label: "25 minutes",
  },
];

export const noShopOptions = [
  {
    value: "refund",
    label: "Refund",
  },
  {
    value: "no_refund",
    label: "No Refund",
  },
  {
    value: "gift_card",
    label: "Gift Card",
  },
];

export const selectionAlgorithm = [
  {
    value: "sequential",
    label: "Sequential",
  },
  {
    value: "random",
    label: "Random",
  },
  {
    value: "reverse",
    label: "Reverse",
  },
];

export const cancellationDays = [
  {
    label: "Days",
    value: "day",
  },
  {
    label: "Hours",
    value: "hour",
  },
];

export const maxBookingDuration = [
  {
    value: "30 minutes",
    label: "30 minutes",
  },
  {
    value: "60 minutes",
    label: "60 minutes",
  },
  {
    value: "90 minutes",
    label: "90 minutes",
  },
  {
    value: "120 minutes",
    label: "120 minutes",
  },
  {
    value: "150 minutes",
    label: "150 minutes",
  },
  {
    value: "180 minutes",
    label: "180 minutes",
  },
  {
    value: "210 minutes",
    label: "210 minutes",
  },
  {
    value: "240 minutes",
    label: "240 minutes",
  },
  {
    value: "270 minutes",
    label: "270 minutes",
  },
  {
    value: "300 minutes",
    label: "300 minutes",
  },
  {
    value: "330 minutes",
    label: "330 minutes",
  },
  {
    value: "360 minutes",
    label: "360 minutes",
  },
  {
    value: "390 minutes",
    label: "390 minutes",
  },
  {
    value: "420 minutes",
    label: "420 minutes",
  },
  {
    value: "450 minutes",
    label: "450 minutes",
  },
  {
    value: "480 minutes",
    label: "480 minutes",
  },
];

export const minBookingDuration = [
  {
    value: "30 minutes",
    label: "30 minutes",
  },
  {
    value: "60 minutes",
    label: "60 minutes",
  },
  {
    value: "90 minutes",
    label: "90 minutes",
  },
  {
    value: "120 minutes",
    label: "120 minutes",
  },
];

export const customerTabs = [
  { label: "All Customers", path: "/customers" },
  { label: "Members", path: "/customers/members" },
  { label: "Non-Members", path: "/customers/non-members" },
];

export const sourcesList = [
  {
    value: "walk_in",
    label: "Walk In",
  },
  {
    value: "phone_in",
    label: "Phone In",
  },
  {
    value: "social_media",
    label: "Social Media",
  },
  {
    value: "email_marketing",
    label: "Email Marketing",
  },
  {
    value: "website_signup",
    label: "Website Signup",
  },
];

export const membershipList = [
  {
    value: 2,
    label: "Gold",
  },
  {
    value: 3,
    label: "Silver",
  },
];

export const weekDaysList = [
  {
    value: "sunday",
    label: "Sunday",
  },
  {
    value: "monday",
    label: "Monday",
  },
];

export const allSlots = [
  { hour: "12:00 AM" },
  { hour: "12:30 AM" },
  { hour: "01:00 AM" },
  { hour: "01:30 AM" },
  { hour: "02:00 AM" },
  { hour: "02:30 AM" },
  { hour: "03:00 AM" },
  { hour: "03:30 AM" },
  { hour: "04:00 AM" },
  { hour: "04:30 AM" },
  { hour: "05:00 AM" },
  { hour: "05:30 AM" },
  { hour: "06:00 AM" },
  { hour: "06:30 AM" },
  { hour: "07:00 AM" },
  { hour: "07:30 AM" },
  { hour: "08:00 AM" },
  { hour: "08:30 AM" },
  { hour: "09:00 AM" },
  { hour: "09:30 AM" },
  { hour: "10:00 AM" },
  { hour: "10:30 AM" },
  { hour: "11:00 AM" },
  { hour: "11:30 AM" },
  { hour: "12:00 PM" },
  { hour: "12:30 PM" },
  { hour: "01:00 PM" },
  { hour: "01:30 PM" },
  { hour: "02:00 PM" },
  { hour: "02:30 PM" },
  { hour: "03:00 PM" },
  { hour: "03:30 PM" },
  { hour: "04:00 PM" },
  { hour: "04:30 PM" },
  { hour: "05:00 PM" },
  { hour: "05:30 PM" },
  { hour: "06:00 PM" },
  { hour: "06:30 PM" },
  { hour: "07:00 PM" },
  { hour: "07:30 PM" },
  { hour: "08:00 PM" },
  { hour: "08:30 PM" },
  { hour: "09:00 PM" },
  { hour: "09:30 PM" },
  { hour: "10:00 PM" },
  { hour: "10:30 PM" },
  { hour: "11:00 PM" },
  { hour: "11:30 PM" },
];

export const operationsType = "simulator";

export const durationLimit = [
  {
    value: 30,
    label: "30",
  },
  {
    value: 60,
    label: "60",
  },
  {
    value: 90,
    label: "90",
  },
  {
    value: 120,
    label: "120",
  },
  {
    value: 150,
    label: "150",
  },
  {
    value: 180,
    label: "180",
  },
  {
    value: 210,
    label: "210",
  },
  {
    value: 240,
    label: "240",
  },
  {
    value: 270,
    label: "270",
  },
  {
    value: 300,
    label: "300",
  },
];

export const guestRange = [
  {
    value: 1,
    label: "1",
  },
  {
    value: 2,
    label: "2",
  },
  {
    value: 3,
    label: "3",
  },
  {
    value: 4,
    label: "4",
  },
  {
    value: 5,
    label: "5",
  },
];

export const maximum_concurrent_bookings = [
  {
    value: 1,
    label: "1",
  },
  {
    value: 2,
    label: "2",
  },
  {
    value: 3,
    label: "3",
  },
  {
    value: 4,
    label: "4",
  },
  {
    value: 5,
    label: "5",
  },
  {
    value: 6,
    label: "6",
  },
  {
    value: 7,
    label: "7",
  },
  {
    value: 8,
    label: "8",
  },
  {
    value: 9,
    label: "9",
  },
  {
    value: 10,
    label: "10",
  },
];

export const advance_booking_days = [
  {
    value: "yes",
    label: "Yes",
  },
  {
    value: "no",
    label: "No",
  },
];

export const guestOptions = [
  { number_of_guests: 1, label: "1 Guest" },
  { number_of_guests: 2, label: "2 Guests" },
  { number_of_guests: 3, label: "3 Guests" },
  { number_of_guests: 4, label: "4 Guests" },
  { number_of_guests: 5, label: "5 Guests" },
  { number_of_guests: 6, label: "6 Guests" },
];

export const QUERY_KEYS = {
  EVENTS: "event_list",
  EVENT_CATEGORIES: "event_categories",
  EVENT_TYPES: "event_types",
  EVENTS_STATISTICS: "events_statistics",
  EVENT_BAYS: "event_bays",
  VISITORS: "visitors",
  TOTAL_NEW_SUBMISSIONS: "total_new_submissions",
};

export const PERMISSION_CATEGORIES = {
  OPERATIONS_ACCESS: {
    title: "Operations Access",
    items: [
      { key: "Dashboard", label: "Dashboard", model: "dashboard" },
      { key: "Bookings", label: "Bookings", model: "booking" },
      {
        key: "Customer Management",
        label: "Customer Management",
        model: "customer",
      }, // API sends "Customer Management", not "Users"
      {
        key: "Membership Plans",
        label: "Membership Plans",
        model: "membershipplan",
      }, // API sends "Membership Plans" (plural)
      { key: "Members", label: "Members", model: "membership" }, // API sends "Members"
      { key: "Calendar Events", label: "Calendar Events", model: "events" }, // API sends "Calendar Events", not "Events"
      {
        key: "Subscriptions",
        label: "Inbox",
        model: "eventsubscription",
        SubKey1: "event subscription",
      },
      { key: "Transactions", label: "Transactions", model: "transaction" }, // API sends "Transactions" (plural)
      { key: "Lesson & Coach", label: "Lesson & Coach", model: "coachprofile" }, // API sends "Lesson & Coach", not "Coaching"
      { key: "Analytics", label: "Analytics", model: "analytics" },
      { key: "Marketing Popups", label: "Marketing Popups", model: "popupconfiguration" },
      { key: "Waitlist Management", label: "Waitlist Management", model: "waitlistentry" }, // API sends "Waitlist Management"
      { key: "User Management", label: "User Management", model: "user" },
    ],
  },
  VENUE_SETTINGS_ACCESS: {
    title: "Venue Settings Access",
    items: [
      {
        key: "General Settings",
        label: "Booking Settings",
        model: "bookingsetting",
        SubKey1: "administrator booking setting",
      },
      {
        key: "Business Hours",
        label: "Business Hours",
        model: "businesshour",
      },
      {
        key: "Pricing Configuration",
        label: "Pricing Configuration",
        model: "season",
      },
      {
        key: "Language & Regional",
        label: "Language & Regional",
        model: "regionalsetting",
      },
      {
        key: "Notifications",
        label: "Notifications",
        model: "notification",
      },
    ],
  },
};

export const ACTIONS = [
  { label: "View", keys: ["view"] },
  { label: "Add/modify", keys: ["add", "change"] },
  { label: "Delete", keys: ["delete"] },
  { label: "Export", keys: ["export"] },
];

export const COUNTRY_CODE_MAP = {
  Afghanistan: "AF",
  "Aland Islands": "AX",
  Albania: "AL",
  Algeria: "DZ",
  "American Samoa": "AS",
  Andorra: "AD",
  Angola: "AO",
  Anguilla: "AI",
  Antarctica: "AQ",
  "Antigua and Barbuda": "AG",
  Argentina: "AR",
  Armenia: "AM",
  Aruba: "AW",
  Australia: "AU",
  Austria: "AT",
  Azerbaijan: "AZ",
  Bahrain: "BH",
  Bangladesh: "BD",
  Barbados: "BB",
  Belarus: "BY",
  Belgium: "BE",
  Belize: "BZ",
  Benin: "BJ",
  Bermuda: "BM",
  Bhutan: "BT",
  Bolivia: "BO",
  "Bonaire, Sint Eustatius and Saba": "BQ",
  "Bosnia and Herzegovina": "BA",
  Botswana: "BW",
  "Bouvet Island": "BV",
  Brazil: "BR",
  "British Indian Ocean Territory": "IO",
  Brunei: "BN",
  Bulgaria: "BG",
  "Burkina Faso": "BF",
  Burundi: "BI",
  Cambodia: "KH",
  Cameroon: "CM",
  Canada: "CA",
  "Cape Verde": "CV",
  "Cayman Islands": "KY",
  "Central African Republic": "CF",
  Chad: "TD",
  Chile: "CL",
  China: "CN",
  "Christmas Island": "CX",
  "Cocos (Keeling) Islands": "CC",
  Colombia: "CO",
  Comoros: "KM",
  Congo: "CG",
  "Cook Islands": "CK",
  "Costa Rica": "CR",
  "Cote D'Ivoire (Ivory Coast)": "CI",
  Croatia: "HR",
  Cuba: "CU",
  "Cura\u00e7ao": "CW",
  Cyprus: "CY",
  "Czech Republic": "CZ",
  "Democratic Republic of the Congo": "CD",
  Denmark: "DK",
  Djibouti: "DJ",
  Dominica: "DM",
  "Dominican Republic": "DO",
  Ecuador: "EC",
  Egypt: "EG",
  "El Salvador": "SV",
  "Equatorial Guinea": "GQ",
  Eritrea: "ER",
  Estonia: "EE",
  Eswatini: "SZ",
  Ethiopia: "ET",
  "Falkland Islands": "FK",
  "Faroe Islands": "FO",
  "Fiji Islands": "FJ",
  Finland: "FI",
  France: "FR",
  "French Guiana": "GF",
  "French Polynesia": "PF",
  "French Southern Territories": "TF",
  Gabon: "GA",
  Georgia: "GE",
  Germany: "DE",
  Ghana: "GH",
  Gibraltar: "GI",
  Greece: "GR",
  Greenland: "GL",
  Grenada: "GD",
  Guadeloupe: "GP",
  Guam: "GU",
  Guatemala: "GT",
  Guernsey: "GG",
  Guinea: "GN",
  "Guinea-Bissau": "GW",
  Guyana: "GY",
  Haiti: "HT",
  "Heard Island and McDonald Islands": "HM",
  Honduras: "HN",
  "Hong Kong S.A.R.": "HK",
  Hungary: "HU",
  Iceland: "IS",
  India: "IN",
  Indonesia: "ID",
  Iran: "IR",
  Iraq: "IQ",
  Ireland: "IE",
  Israel: "IL",
  Italy: "IT",
  Jamaica: "JM",
  Japan: "JP",
  Jersey: "JE",
  Jordan: "JO",
  Kazakhstan: "KZ",
  Kenya: "KE",
  Kiribati: "KI",
  Kosovo: "XK",
  Kuwait: "KW",
  Kyrgyzstan: "KG",
  Laos: "LA",
  Latvia: "LV",
  Lebanon: "LB",
  Lesotho: "LS",
  Liberia: "LR",
  Libya: "LY",
  Liechtenstein: "LI",
  Lithuania: "LT",
  Luxembourg: "LU",
  "Macau S.A.R.": "MO",
  Madagascar: "MG",
  Malawi: "MW",
  Malaysia: "MY",
  Maldives: "MV",
  Mali: "ML",
  Malta: "MT",
  "Man (Isle of)": "IM",
  "Marshall Islands": "MH",
  Martinique: "MQ",
  Mauritania: "MR",
  Mauritius: "MU",
  Mayotte: "YT",
  Mexico: "MX",
  Micronesia: "FM",
  Moldova: "MD",
  Monaco: "MC",
  Mongolia: "MN",
  Montenegro: "ME",
  Montserrat: "MS",
  Morocco: "MA",
  Mozambique: "MZ",
  Myanmar: "MM",
  Namibia: "NA",
  Nauru: "NR",
  Nepal: "NP",
  Netherlands: "NL",
  "New Caledonia": "NC",
  "New Zealand": "NZ",
  Nicaragua: "NI",
  Niger: "NE",
  Nigeria: "NG",
  Niue: "NU",
  "Norfolk Island": "NF",
  "North Korea": "KP",
  "North Macedonia": "MK",
  "Northern Mariana Islands": "MP",
  Norway: "NO",
  Oman: "OM",
  Pakistan: "PK",
  Palau: "PW",
  "Palestinian Territory Occupied": "PS",
  Panama: "PA",
  "Papua New Guinea": "PG",
  Paraguay: "PY",
  Peru: "PE",
  Philippines: "PH",
  "Pitcairn Island": "PN",
  Poland: "PL",
  Portugal: "PT",
  "Puerto Rico": "PR",
  Qatar: "QA",
  Reunion: "RE",
  Romania: "RO",
  Russia: "RU",
  Rwanda: "RW",
  "Saint Helena": "SH",
  "Saint Kitts and Nevis": "KN",
  "Saint Lucia": "LC",
  "Saint Pierre and Miquelon": "PM",
  "Saint Vincent and the Grenadines": "VC",
  "Saint-Barthelemy": "BL",
  "Saint-Martin (French part)": "MF",
  Samoa: "WS",
  "San Marino": "SM",
  "Sao Tome and Principe": "ST",
  "Saudi Arabia": "SA",
  Senegal: "SN",
  Serbia: "RS",
  Seychelles: "SC",
  "Sierra Leone": "SL",
  Singapore: "SG",
  "Sint Maarten (Dutch part)": "SX",
  Slovakia: "SK",
  Slovenia: "SI",
  "Solomon Islands": "SB",
  Somalia: "SO",
  "South Africa": "ZA",
  "South Georgia": "GS",
  "South Korea": "KR",
  "South Sudan": "SS",
  Spain: "ES",
  "Sri Lanka": "LK",
  Sudan: "SD",
  Suriname: "SR",
  "Svalbard and Jan Mayen Islands": "SJ",
  Sweden: "SE",
  Switzerland: "CH",
  Syria: "SY",
  Taiwan: "TW",
  Tajikistan: "TJ",
  Tanzania: "TZ",
  Thailand: "TH",
  "The Bahamas": "BS",
  "The Gambia ": "GM",
  "Timor-Leste": "TL",
  Togo: "TG",
  Tokelau: "TK",
  Tonga: "TO",
  "Trinidad and Tobago": "TT",
  Tunisia: "TN",
  Turkey: "TR",
  Turkmenistan: "TM",
  "Turks and Caicos Islands": "TC",
  Tuvalu: "TV",
  Uganda: "UG",
  Ukraine: "UA",
  "United Arab Emirates": "AE",
  "United Kingdom": "GB",
  "United States": "US",
  "United States Minor Outlying Islands": "UM",
  Uruguay: "UY",
  Uzbekistan: "UZ",
  Vanuatu: "VU",
  "Vatican City State (Holy See)": "VA",
  Venezuela: "VE",
  Vietnam: "VN",
  "Virgin Islands (British)": "VG",
  "Virgin Islands (US)": "VI",
  "Wallis and Futuna Islands": "WF",
  "Western Sahara": "EH",
  Yemen: "YE",
  Zambia: "ZM",
  Zimbabwe: "ZW",
};

export const eventCancellationReasons = [
  { value: "event_rescheduling", label: "Event Rescheduling" },
  { value: "weather_conditions", label: "Severe Weather Conditions" },
  { value: "venue_unavailable", label: "Venue Unavailable" },
];

export const eventRefundOptions = [
  { value: "full_refund", label: "Full Refund" },
  { value: "partial_refund", label: "Partial Refund" },
  { value: "credit_to_account", label: "Credit to Account" },
  { value: "reschedule_no_refund", label: "Reschedule (No Refund)" },
  { value: "no_refund", label: "No Refund" },
];

export const bookingRefundOptions = [
  { value: "refund", label: "Refund" },
  { value: "no_refund", label: "No refund" },
];

export const bookingRefundReasons = [
  { value: "customer_request", label: "Customer Request" },
  { value: "cancel_booking", label: "Cancel Booking" },
  { value: "duplicate_payment", label: "Duplicate Payment" },
  { value: "other", label: "Other" },
];

export const seasonsTypes = [
  {
    label: "Peak Season",
    value: "Peak",
  },
  {
    label: "Off-Peak Season",
    value: "Off-Peak",
  },
  {
    label: "Closed Season",
    value: "Closed",
  },
];
